/**
 * Dependencies
 */
import http from '../../../services/HttpService'

/**
 * Next page
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const nextPage = ({ commit }) => commit('PAGINATE_FORWARD')

/**
 * Previous Page
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const prevPage = ({ commit }) => commit('PAGINATE_BACKWARD')

/**
 * First Page
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const firstPage = ({ commit }) => commit('PAGINATE_FIRST')

/**
 * Last Page
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const lastPage = ({ commit }) => commit('PAGINATE_LAST')

/**
 * Execute call to update a user's file mapping
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const updateMapping = ({ commit, state, dispatch }, payload) => {
    const url = `data-import/import-files/${state.meta.rentroll_file_id}/update/`

    commit('SET_UPDATE_MAPPING')
    http.patch(url, { mapping: payload })
        .then(res => {
            setTimeout(() => {
                commit('LOAD_NEW_MAPPING', res.data)
                commit('RESET_UPDATE_MAPPING')
                dispatch('addNotification', {
                    type: 'success',
                    title: 'Mapping Updated',
                    text: 'The file mappings have been updated successfully.',
                    timeout: true
                }, { root: true })
            }, 1500)
        })
        .catch(err => {
            setTimeout(() => {
                commit('RESET_UPDATE_MAPPING', err)
            }, 1500)
        })
}

/**
 * Upload a file with metadata to be processed
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
const uploadFile = ({ commit }, payload) => {
    const url = 'data-import/import-files/rentroll/'
    const headers = { 'Content-Type': 'multipart/form-data' }

    commit('RESET_STATE')
    commit('SET_LOADING')
    http.post(url, payload, { headers: headers })
        .then(res => {
            commit('GET_DATA_SUCCESS', res.data)
            commit('RESET_LOADING')
        })
        .catch(e => {
            if (e.response) {
                switch (e.response.data.error_type) {
                    case 'file_rejected':
                        commit('FILE_REJECTED', e.response.data)
                        commit('RESET_LOADING')
                        break
                    default:
                        commit('FILE_FAILED', e.response.data.message)
                        commit('RESET_LOADING')
                        break
                }
            } else {
                commit('FILE_FAILED', 'There was a problem uploading the file.')
                commit('RESET_LOADING')
            }
        })
}

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const resetState = ({ commit }) => commit('RESET_STATE')

/**
 * Update the mappings and get a new rendered dataset
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const importData = ({ commit, state, dispatch }) => {
    return new Promise((resolve, reject) => {
        commit('ATTEMPT_IMPORT')
        http.get(`data-import/import-files/${state.meta.rentroll_file_id}/import/`)
            .then(res => {
                commit('projects/form/IMPORT_UNIT_VALUES', res.data, { root: true })
                commit('projects/form/UPDATE_FILE_ID', {
                    id: state.meta.rentroll_file_id,
                    type: 'rentroll_file_id'
                }, { root: true })
                dispatch('addNotification', {
                    type: 'success',
                    title: 'Rent Roll Imported',
                    text: 'Rent Roll was successfully imported to your project.',
                    timeout: true
                }, { root: true })
                commit('RESET_ATTEMPT_IMPORT')
                resolve()
            })
            .catch(err => {
                dispatch('addNotification', {
                    type: 'error',
                    title: 'Import Failed',
                    text: 'Rent Roll was not successfully imported.',
                    timeout: true
                }, { root: true })
                commit('RESET_ATTEMPT_IMPORT')
                reject(err)
            })
    })
}

/**
 * Allow the user to request assistance with a file that fails to upload properly
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
const requestFileAssistance = ({ commit, state }) => {
    commit('REQUEST_FILE_ASSISTANCE')
    http.post(`data-import/import-files/${state.meta.rentroll_file_id}/support/`)
        .then(res => commit('SUPPORT_REQUEST_SUCCESS', res.data))
        .catch(err => commit('SUPPORT_REQUEST_FAILURE', err))
}

/**
 * Update the selected tab
 *
 * @param  {Function} options.commit
 * @param  {Number} tab
 * @return {Promise}
 */
const changeTab = ({ commit }, tab) => commit('CHANGE_TAB', tab)

export default {
    nextPage,
    prevPage,
    lastPage,
    changeTab,
    firstPage,
    importData,
    resetState,
    uploadFile,
    updateMapping,
    requestFileAssistance
}



// WEBPACK FOOTER //
// ./src/state/modules/rent-roll-importer/actions.js